import React from 'react';
import {CheckBoxInput, CheckBoxLabel} from "./input.styles";

const CheckBox = ({checked, name, label, value, id, iconName, iconEnd = false, classNames, onChange}) => {
    return (
        <div className={`position-relative ${classNames}`}>
            <CheckBoxInput type='checkbox' {...{checked, name, id, value, onChange}} />
            <CheckBoxLabel className={iconEnd ? 'flex-row-reverse' : ''} htmlFor={id}>
                <i className={`${iconName} ${iconEnd ? 'me-2' : 'ms-2'}`}/>
                {label}
            </CheckBoxLabel>
        </div>
    );
};

export default CheckBox;
